import { GetServerSidePropsContext } from "next";
import { SWRConfig } from "swr";

import Bugsnag from "@bugsnag/js";

import { discussionUrl as getDiscussionUrl } from "components/DiscussionModal";
import ProfilePageContainer, {
  profileUrl as getProfileUrl,
} from "components/ProfilePageLayout";
import ProfilePageDiscussions from "components/ProfilePageLayout/ProfilePageDiscussions";
import { profileDiscussionsUrl } from "components/ProfilePageLayout/ProfilePageDiscussions/ProfilePageDiscussionsList";
import type { NextPageWithLayout } from "pages/_app";
import { baseFetcher } from "utils/baseFetcher";
import { isSsr } from "utils/isSsr";

const ProfileDiscussionsPage: NextPageWithLayout = () => {
  return <ProfilePageDiscussions />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const slug = context.params?.slug as string;
    const discussionId = context.query.discussion as string;

    const profileUrl = getProfileUrl(slug);

    const discussionsUrl = profileDiscussionsUrl(slug, 1);
    const discussionUrl = getDiscussionUrl(discussionId);

    const [profile, discussions, discussion] = await Promise.all([
      baseFetcher(profileUrl, context),
      isSsr(context)
        ? baseFetcher(discussionsUrl, context)
        : Promise.resolve({}),
      isSsr(context) && discussionId
        ? baseFetcher(discussionUrl, context)
        : Promise.resolve({}),
    ]);

    if (!profile || profile.errors?.length) return { notFound: true };

    return {
      props: {
        slug,
        profile,
        fallback: {
          [profileUrl]: profile,
          [`$inf$${discussionsUrl}`]: [discussions],
          [discussionUrl]: discussion,
        },
      },
    };
  } catch (error: any) {
    console.error(
      "[slug].tsx ~ getServerSideProps profile discussions Page ~ error",
      error
    );
    Bugsnag.notify(error);
    return { notFound: true };
  }
}

ProfileDiscussionsPage.getLayout = (page, { pageProps }) => {
  const { fallback } = pageProps;

  return (
    <SWRConfig value={{ fallback }}>
      <ProfilePageContainer {...pageProps}>{page}</ProfilePageContainer>
    </SWRConfig>
  );
};

export default ProfileDiscussionsPage;
